import React, { MouseEventHandler } from 'react';
import { List } from 'immutable';
import useAppContext from 'flow/hooks/useAppContext';
import { Voicemail } from 'flow/types/Voicemail';
import { TypedMap } from 'flow/types/TypedMap';
import { calcTotalUnreadVoiceMessages } from 'flow/utils/extension-utils';
import PbxListItem from './PbxListItem';
import { RowMarking } from './BaseListItem';

interface Props {
    item: TypedMap<Voicemail>;
    onClick: MouseEventHandler;
    marking?: RowMarking;
}

const ListItemPbxVoicemail = ({ item, onClick, marking }: Props) => {
    const { i18next } = useAppContext();
    const unreadCount = calcTotalUnreadVoiceMessages(
        item.get('voiceMessages', List()),
    );

    return (
        <PbxListItem
            onClick={onClick}
            marking={marking}
            type="voicemail"
            title={item.get('description')}
            description={
                unreadCount > 0
                    ? `${unreadCount} ${
                          unreadCount === 1
                              ? i18next.t('pbx.message_singular')
                              : i18next.t('pbx.message_plural')
                      }`
                    : i18next.t('pbx.no_messages')
            }
            notificationCount={unreadCount}
            phoneNumber={item.has('number') && item.getIn(['number', 'number'])}
        />
    );
};

export default ListItemPbxVoicemail;
